//import $ from 'jquery';
import 'jquery.cookie';
import '@fancyapps/ui/dist/fancybox.umd';
import 'slick-carousel';
import 'jquery-ui-dist/jquery-ui.js';
import Headroom from "headroom.js";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import './community-groups';
import './map';

gsap.registerPlugin(ScrollTrigger);

/* ==========================================================================
   Fade in elements with intersection observer
   ========================================================================== */

if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting === true) {
                entry.target.classList.add("fade-in--is-visible");
            } else {
                //entry.target.classList.remove("fade-in--is-visible");
            }
        });
    });
    var items = document.querySelectorAll(".fade-in");
    items.forEach(function (item, index) {
        observer.observe(item, index);
    });
} else {
    document.querySelector("body").classList.add("no-intersection-observer")
}

/* ==========================================================================
   Change header on scroll
   ========================================================================== */

if (document.querySelector(".header")) {
    var headroomOptions = {
        offset: {
            up: 0,
            down: 110
        }
    }
    const headroomHeader = document.querySelector(".header");
    const headroom = new Headroom(headroomHeader, headroomOptions);
    headroom.init();
}

/* ==========================================================================
   Mobile Menu Button
   ========================================================================== */

$(".js-toggle-mobile-nav").click(function (e) {
    e.preventDefault();
    $(this).toggleClass("is-active");
    $(".header__secondary").fadeToggle(250);

    //Move the search bar into the mobile menu
    if ($(".header__primary .header-search").length) {
        $(".header__secondary-wrapper").prepend($(".header-search"));
    }
});

/* ==========================================================================
   Sub nav 
   ========================================================================== */

if (window.matchMedia("(max-width: 1024px)").matches) {
    $(".js-toggle-subnav").click(function (e) {
        e.preventDefault();
        var thisNav = $(this).parent().find(".sub-nav");
        $(".main-nav__subnav-button").not(this).removeClass("subnav-active");
        $(".sub-nav").not(thisNav).fadeOut(250);
        $(this).toggleClass("subnav-active");
        $(this).parent().find(".sub-nav").fadeToggle(250);
    });

    $(".js-close-subnav").click(function (e) {
        e.preventDefault();
        $(".sub-nav").fadeOut(250);
        $(".main-nav__subnav-button").removeClass("subnav-active");
    });
}

/* ==========================================================================
  jQuery UI - Accordion
   ========================================================================== */

if (document.querySelector(".accordion")) {
    $(".accordion").accordion({
        collapsible: true,
        heightStyle: "content",
        active: false
    });
}

/* ==========================================================================
   Event Filters
   ========================================================================== */
$(".js-event-filter-button").not(".disabled").on('click', function (e) {
    console.log("test");
    $(this).toggleClass("is-active");
    if ($(this).data("filter") != "all") {
        $(".js-event-filter-button[data-filter='all']").removeClass("is-active");
    } else {
        $(".js-event-filter-button[data-filter!='all']").removeClass("is-active");
    }
    filterSelection();
});
function filterSelection() {
    $('.community-groups-tile').hide();
    $(".js-event-filter-button.is-active").each(function (index) {
        var filter = $(this).data("filter");
        if (filter == "all") filter = "";
        $('.community-groups-tile').each(function (index) {
            if ($(this).data("filter").indexOf(filter) > -1) $(this).show();
        });
    });
}

/* ==========================================================================
   Back to top button
   ========================================================================== */

$('.js-back-to-top').on('click', function (e) {
    e.preventDefault();
    $('html, body').animate({ scrollTop: 0 }, '150');
});

/* ==========================================================================
   Cookies Banner
   ========================================================================== */

$(document).ready(function () {
    if (typeof $.cookie('_ll_userCkAccept') === 'undefined') {
        if (document.querySelector(".cookies-popup")) {
            $(".cookies-popup").show();
        }
    }

    $('.definition').each(function () {
        const title = $(this).text();
        if (jsDefinitionDictionary.some(x => x.title === title)) {
            const [{ description }] = jsDefinitionDictionary.filter(x => x.title === title);

            $(this).attr('data-tooltip', description);
        }
        return $(this);
    });
});

/* ==========================================================================
   Cookies Close Button
   ========================================================================== */

if (document.querySelector(".js-close-cookies-popup")) {
    document.querySelector(".js-close-cookies-popup").addEventListener("click", function (event) {
        event.preventDefault();
        $(".cookies-popup").hide();
        $.cookie("_ll_userCkAccept", true, { expires: 365, path: '/' });
    });
}

/* ==========================================================================
   Slick Sliders
   ========================================================================== */

if ($('.js-article-slider').length) {
    $('.js-article-slider').each(function () {
        $(this).slick({
            dots: true,
            arrows: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            prevArrow: '<button class="slick-prev slick-arrow"><span class="screen-reader-text">Previous slide</span> <svg class="icon" role="presentation"><use xlink:href="#icon-chevron-circle-left"></use></svg></button>',
            nextArrow: '<button class="slick-next slick-arrow"><span class="screen-reader-text">Next slide</span> <svg class="icon" role="presentation"><use xlink:href="#icon-chevron-circle-right"></use></svg></button>',
            appendArrows: $(this).parents(".article-slider").find(".arrows-append"),
            appendDots: $(this).parents(".article-slider").find(".dots-append"),
            responsive: [
                {
                    breakpoint: 1025,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 769,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 760,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ]
        });

        $(this).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            var direction = "";
            $(this).removeClass("direction-right direction-left");
            if (Math.abs(nextSlide - currentSlide) == 1) {
                direction = (nextSlide - currentSlide > 0) ? "direction-right" : "direction-left";
                $(this).addClass(direction);
            } else {
                direction = (nextSlide - currentSlide > 0) ? "direction-left" : "direction-right";
                $(this).addClass(direction);
            }
        });
    });
}

if ($('.js-quote-slider').length) {
    $('.js-quote-slider').each(function () {
        $(this).slick({
            fade: true,
            dots: true,
            arrows: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: '<button class="slick-prev slick-arrow"><span class="screen-reader-text">Previous slide</span> <svg class="icon" role="presentation"><use xlink:href="#icon-chevron-circle-left"></use></svg></button>',
            nextArrow: '<button class="slick-next slick-arrow"><span class="screen-reader-text">Next slide</span> <svg class="icon" role="presentation"><use xlink:href="#icon-chevron-circle-right"></use></svg></button>',
            appendArrows: $(this).parents(".quote-slider").find(".arrows-append"),
            appendDots: $(this).parents(".quote-slider").find(".dots-append")
        });

        $(this).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            var direction = "";
            $(this).removeClass("direction-right direction-left");
            if (Math.abs(nextSlide - currentSlide) == 1) {
                direction = (nextSlide - currentSlide > 0) ? "direction-right" : "direction-left";
                $(this).addClass(direction);
            } else {
                direction = (nextSlide - currentSlide > 0) ? "direction-left" : "direction-right";
                $(this).addClass(direction);
            }
        });
    });
}

$('.js-action-slider').slick({
    dots: true,
    arrows: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow: '<button class="slick-prev slick-arrow"><span class="screen-reader-text">Previous slide</span> <svg class="icon" role="presentation"><use xlink:href="#icon-chevron-left"></use></svg></button>',
    nextArrow: '<button class="slick-next slick-arrow"><span class="screen-reader-text">Next slide</span> <svg class="icon" role="presentation"><use xlink:href="#icon-chevron-right"></use></svg></button>',
    appendArrows: $(".js-action-slider-arrows"),
    responsive: [
        {
            breakpoint: 760,
            settings: {
                slidesToShow: 1,
            }
        }
    ]
});

$(".js-action-slider").on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    var direction = "";
    $(this).removeClass("direction-right direction-left");
    if (Math.abs(nextSlide - currentSlide) == 1) {
        direction = (nextSlide - currentSlide > 0) ? "direction-right" : "direction-left";
        $(this).addClass(direction);
    } else {
        direction = (nextSlide - currentSlide > 0) ? "direction-left" : "direction-right";
        $(this).addClass(direction);
    }
});

/* ==========================================================================
   Wrap tables for responsive styles
   ========================================================================== */

$('.umb-block-list table').each(function (index) {
    $(this).wrap('<div class="table-wrapper"></div>');
});

/* ==========================================================================
Greensock - Parallax 
========================================================================== */

if (window.matchMedia("(min-width: 	1441px)").matches) {
    gsap.utils.toArray(".parallax-image").forEach(layer => {
        gsap.to(layer, {
            yPercent: 2,
            ease: "none",
            scrollTrigger: {
                trigger: layer,
                start: "top top",
                end: "bottom top",
                scrub: 0.1,
                pin: true,
                pinSpacing: false
            },
        });
    });
}

/* ==========================================================================
   Sticky Social Share - Copy current page URL
   ========================================================================== */

$("a.sticky-social-share__link.js-copy-url").click(function (event) {
    event.preventDefault();
    navigator.clipboard.writeText($(this).attr("href"));
});

/* ==========================================================================
   Shielded Site
   ========================================================================== */

(function () {
    window.onload = function () {
        var frameName = new ds07o6pcmkorn({
            openElementId: "#shielded-logo",
            modalID: "modal",
        });
        frameName.init();
    }
})();
